/**
 * FDV — celebración al desbloquear un regalo del carrito. Doc 16 §2.3 (Etapa 4).
 *
 * Escucha `fdv:gift:unlocked` (evento DOM del motor de regalos, patch #24) y
 * lanza un confeti breve. Refuerzo positivo justo antes de "pagar" → reduce el
 * abandono de último momento.
 *
 * Solo para las ofertas de umbral (`kind: 'threshold'` — envío gratis $699,
 * vela del zodiaco $999…). Los regalos emparejados a un producto
 * (`kind: 'binary'`, p. ej. vela → carta del tarot) usan el toast suave de
 * `fdv-gift-toast.js`: el confeti para "agregaste una vela" sería demasiado.
 *
 * Sin librería. Respeta `prefers-reduced-motion` (no hace nada). Se carga global
 * desde snippets/fdv-gift-engine.liquid; inerte hasta que el evento dispara.
 */

const COLORS = ['#c89e34', '#3b2a4d', '#efe6d2', '#6a5d86', '#8a6a19'];
const PIECES = 34;
const DURATION = 2600;
const COOLDOWN = 1500;

let last = 0;
let styled = false;

function injectStyles() {
  if (styled || document.getElementById('fdv-celebrate-styles')) return;
  styled = true;
  const el = document.createElement('style');
  el.id = 'fdv-celebrate-styles';
  el.textContent = `
  .fdv-confetti-layer{position:fixed;inset:0;pointer-events:none;z-index:2147483001;overflow:hidden}
  .fdv-confetti{position:absolute;top:-16px;width:8px;height:13px;border-radius:1px;will-change:transform,opacity;
    animation:fdv-confetti-fall linear forwards}
  @keyframes fdv-confetti-fall{
    0%{transform:translateY(-10px) rotate(0);opacity:1}
    100%{transform:translateY(102vh) rotate(720deg);opacity:.15}
  }`;
  document.head.appendChild(el);
}

function burst() {
  injectStyles();
  const layer = document.createElement('div');
  layer.className = 'fdv-confetti-layer';
  layer.setAttribute('aria-hidden', 'true');

  for (let i = 0; i < PIECES; i++) {
    const p = document.createElement('i');
    p.className = 'fdv-confetti';
    const dur = DURATION + Math.random() * 900;
    p.style.left = Math.random() * 100 + 'vw';
    p.style.background = COLORS[i % COLORS.length];
    p.style.animationDuration = dur + 'ms';
    p.style.animationDelay = Math.random() * 250 + 'ms';
    p.style.transform = `rotate(${Math.random() * 360}deg)`;
    if (Math.random() < 0.5) p.style.borderRadius = '50%';
    layer.appendChild(p);
  }

  document.body.appendChild(layer);
  setTimeout(() => layer.remove(), DURATION + 1400);
}

function onUnlocked(e) {
  const offer = e && e.detail && e.detail.offer;
  // Regalos emparejados a un producto → toast suave (fdv-gift-toast.js), sin confeti.
  if (offer && offer.kind === 'binary') return;
  const now = Date.now();
  if (now - last < COOLDOWN) return; // varios umbrales a la vez → un solo burst
  last = now;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  burst();
}

document.addEventListener('fdv:gift:unlocked', onUnlocked);
